import { render, staticRenderFns } from "./OrderStatusSelector.vue?vue&type=template&id=480248e4&"
import script from "./OrderStatusSelector.vue?vue&type=script&lang=js&"
export * from "./OrderStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports